'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));
var nthGrid = require('@narvar/nth-grid');
var TextLink = _interopDefault(require('@narvar/nth-text-link'));

var narvarLogo = 'M33.686 12.565c.736 0 1.43.144 2.08.43a5.675 5.675 0 0 1 2.904 2.88c.289.644.433 1.332.433 2.063v5.372H38.02v-5.372c0-.587-.116-1.143-.347-1.666a4.421 4.421 0 0 0-.932-1.365 4.476 4.476 0 0 0-1.376-.924 4.182 4.182 0 0 0-1.68-.344c-.592 0-1.152.116-1.68.344-.527.23-.985.538-1.375.924-.39.387-.701.842-.932 1.365a4.078 4.078 0 0 0-.347 1.666v5.372h-1.084v-5.372c0-.731.142-1.419.424-2.063a5.633 5.633 0 0 1 1.148-1.709 5.36 5.36 0 0 1 1.712-1.17 5.283 5.283 0 0 1 2.135-.431M45.821 22.235c.592 0 1.152-.115 1.68-.344a4.456 4.456 0 0 0 1.376-.924c.39-.386.7-.842.931-1.365a4.072 4.072 0 0 0 .348-1.665c0-.586-.117-1.142-.348-1.665a4.41 4.41 0 0 0-.93-1.365 4.476 4.476 0 0 0-1.377-.924 4.187 4.187 0 0 0-1.68-.344 4.18 4.18 0 0 0-1.68.344 4.47 4.47 0 0 0-1.375.924c-.39.387-.702.842-.932 1.365a4.069 4.069 0 0 0-.347 1.666c0 .587.115 1.142.347 1.664.23.523.541.979.932 1.365.39.387.848.695 1.376.924a4.17 4.17 0 0 0 1.68.344zm0-9.67c.751 0 1.46.14 2.124.42a5.361 5.361 0 0 1 1.723 1.138 5.32 5.32 0 0 1 1.148 1.709 5.29 5.29 0 0 1 .423 2.105v5.373h-1.083v-2.15a5.497 5.497 0 0 1-1.886 1.56 5.282 5.282 0 0 1-2.449.59 5.4 5.4 0 0 1-2.134-.42 5.388 5.388 0 0 1-1.712-1.138 5.353 5.353 0 0 1-1.149-1.698 5.277 5.277 0 0 1-.423-2.116 5.3 5.3 0 0 1 .423-2.106 5.32 5.32 0 0 1 1.149-1.709 5.388 5.388 0 0 1 1.712-1.139 5.39 5.39 0 0 1 2.134-.42zM58.176 12.565c.737 0 1.43.14 2.08.42a5.69 5.69 0 0 1 1.723 1.138c.499.48.893 1.05 1.181 1.709.29.658.434 1.36.434 2.105H62.51c0-.586-.116-1.142-.347-1.665a4.421 4.421 0 0 0-.931-1.365 4.48 4.48 0 0 0-1.376-.924 4.185 4.185 0 0 0-1.68-.344 4.18 4.18 0 0 0-1.68.344 4.47 4.47 0 0 0-1.375.924c-.39.387-.701.842-.932 1.365a4.069 4.069 0 0 0-.347 1.666v5.372h-1.084v-5.372a5.3 5.3 0 0 1 .423-2.106 5.32 5.32 0 0 1 1.149-1.709 5.388 5.388 0 0 1 1.712-1.139 5.389 5.389 0 0 1 2.134-.42M73.288 12.565v5.373a4.08 4.08 0 0 1-.346 1.664 4.43 4.43 0 0 1-.932 1.365c-.39.387-.849.695-1.376.924a4.175 4.175 0 0 1-1.68.344l-2.998-.008v-9.662h-1.062V23.31h4.06c.737 0 1.43-.14 2.081-.42a5.688 5.688 0 0 0 1.722-1.138 5.312 5.312 0 0 0 1.181-1.698c.29-.652.434-1.357.434-2.117v-5.372h-1.084M81.09 22.235c.592 0 1.152-.115 1.68-.344a4.45 4.45 0 0 0 1.375-.924c.39-.386.701-.842.932-1.365a4.071 4.071 0 0 0 .347-1.665c0-.586-.116-1.142-.347-1.665a4.411 4.411 0 0 0-.932-1.365 4.47 4.47 0 0 0-1.376-.924 4.182 4.182 0 0 0-1.68-.344c-.592 0-1.152.116-1.68.344-.527.23-.985.538-1.375.924-.39.387-.7.842-.932 1.365a4.07 4.07 0 0 0-.347 1.666c0 .587.116 1.142.347 1.664.231.523.542.979.932 1.365.39.387.848.695 1.376.924a4.173 4.173 0 0 0 1.68.344zm0-9.67c.75 0 1.458.14 2.123.42a5.368 5.368 0 0 1 1.723 1.138 5.32 5.32 0 0 1 1.149 1.709 5.3 5.3 0 0 1 .422 2.105v5.373h-1.083v-2.15a5.49 5.49 0 0 1-1.886 1.56 5.282 5.282 0 0 1-2.448.59 5.403 5.403 0 0 1-3.847-1.558 5.353 5.353 0 0 1-1.148-1.698 5.278 5.278 0 0 1-.424-2.116 5.3 5.3 0 0 1 .424-2.106 5.32 5.32 0 0 1 1.148-1.709 5.385 5.385 0 0 1 1.712-1.139c.657-.28 1.369-.42 2.135-.42zM93.445 12.565a5.2 5.2 0 0 1 2.08.42c.65.278 1.224.658 1.722 1.138a5.298 5.298 0 0 1 1.615 3.815H97.78c0-.587-.116-1.143-.347-1.666a4.421 4.421 0 0 0-.932-1.365 4.476 4.476 0 0 0-1.376-.924 4.182 4.182 0 0 0-1.68-.344c-.592 0-1.152.116-1.68.344a4.47 4.47 0 0 0-1.375.924c-.39.387-.701.842-.932 1.365a4.06 4.06 0 0 0-.347 1.666v5.372h-1.083v-5.372a5.3 5.3 0 0 1 .422-2.106 5.329 5.329 0 0 1 1.149-1.709 5.394 5.394 0 0 1 1.712-1.139 5.392 5.392 0 0 1 2.135-.42M20.181 13.55c-.711 1.683-2.395 2.908-4.235 2.984-1.028.043-2.063.007-3.091.007a.525.525 0 0 1-.517-.524V12.39c0-.276.013-.555-.002-.831-.05-.931-.557-1.85-1.362-2.342-.822-.501-1.878-.656-2.767-.218-.823.404-1.481 1.115-1.687 2.027-.084.375-.075.747-.075 1.128v3.872a.525.525 0 0 1-.524.516h-.867a.525.525 0 0 1-.516-.524v-2.303c0-.827-.078-1.7.027-2.524.247-1.927 1.603-3.675 3.525-4.18a4.91 4.91 0 0 1 5.23 1.883c.59.817.926 1.79.926 2.801v2.936c.387 0 .774.003 1.16.004.508.002 1.012-.023 1.477-.252 1.077-.53 1.762-1.544 1.762-2.756V8.048c0-.175.072-.304.178-.387a.489.489 0 0 1 .347-.129h.866c.285 0 .517.242.517.524v2.397c0 1.056.05 2.099-.372 3.098zM12.409.13C5.781.13.41 5.5.41 12.125c0 6.625 5.372 11.995 12 11.995s12-5.37 12-11.995C24.41 5.5 19.038.13 12.41.13z';

var NarvarLogo = function NarvarLogo(_ref) {
  var s = _ref.s;
  return React.createElement(
    'svg',
    { width: s.width, height: s.height, viewBox: '0 0 99 25' },
    React.createElement(
      'g',
      { fill: s.fill, fillRule: 'evenodd' },
      React.createElement('path', { d: narvarLogo }),
      React.createElement(
        'text',
        { fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif', fontSize: '9', fontWeight: '260', letterSpacing: '.32', transform: 'translate(0 -1)' },
        React.createElement(
          'tspan',
          { x: '28', y: '9', fill: s.fill },
          'POWERED BY'
        )
      )
    )
  );
};

NarvarLogo.defaultProps = {
  s: {
    width: '6.1875rem',
    height: '1.5625rem',
    fill: '#ccc'
  }
};

NarvarLogo.propTypes = {
  s: PropTypes.shape({
    width: PropTypes.string,
    height: PropTypes.string,
    fill: PropTypes.string
  })
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var LEFT = 'left';
var RIGHT = 'right';

var NarvarFooter = function NarvarFooter(_ref) {
  var logoHref = _ref.logoHref,
      links = _ref.links,
      align = _ref.align,
      footerStyle = _ref.footerStyle,
      linkStyle = _ref.linkStyle,
      linkHoverStyle = _ref.linkHoverStyle;
  return React.createElement(
    'footer',
    null,
    React.createElement(
      nthGrid.Row,
      {
        'lg-style': 'padding: 0.625rem 0 6.25rem;',
        'md-style': 'padding: 1.25rem 1.25rem 5rem; background: #fff',
        'xs-style': 'padding: 0.625rem 1.25rem 5rem;',
        style: _extends({
          borderTop: '1px solid #ccc'
        }, footerStyle)
      },
      React.createElement(
        nthGrid.Column,
        {
          'xs-columns': 6,
          style: _extends({
            padding: 0,
            textAlign: 'left'
          }, align === LEFT ? { width: 'auto' } : {})
        },
        React.createElement(
          'a',
          { href: logoHref, target: '_blank', rel: 'noopener noreferrer' },
          React.createElement(NarvarLogo, null)
        )
      ),
      React.createElement(
        nthGrid.Column,
        {
          'xs-columns': 6,
          style: _extends({
            padding: 0,
            textAlign: align === LEFT ? LEFT : RIGHT
          }, align === LEFT ? { width: 'auto' } : {})
        },
        links.reduce(function (footerLinkElements, _ref2, index, _ref3) {
          var href = _ref2.href,
              text = _ref2.text;
          var length = _ref3.length;

          var key = '' + href + text;
          var newFooterLinkElements = footerLinkElements.concat(React.createElement(
            TextLink,
            {
              s: _extends({
                margin: '0 2px',
                fontSize: '9px',
                color: '#999',
                hoverColor: linkHoverStyle.color || '#999'
              }, linkStyle),
              href: href,
              key: key,
              target: '_blank',
              rel: 'noopener noreferrer'
            },
            text
          ));

          if (index === length - 1) return newFooterLinkElements;

          return newFooterLinkElements.concat(React.createElement(
            'span',
            {
              key: key + '-divider',
              style: _extends({
                fontSize: '9px',
                color: '#999'
              }, linkStyle)
            },
            '|'
          ));
        }, [])
      )
    )
  );
};

NarvarFooter.defaultProps = {
  align: '',
  logoHref: 'https://corp.narvar.com/survey',
  links: [{
    text: 'Terms of Use',
    href: 'https://corp.narvar.com/terms/'
  }, {
    text: 'Privacy Policy',
    href: 'https://corp.narvar.com/privacy-policy/'
  }],
  footerStyle: {},
  linkStyle: {},
  linkHoverStyle: {}
};

NarvarFooter.propTypes = {
  logoHref: PropTypes.string,
  align: PropTypes.oneOf(['', LEFT, RIGHT]),
  links: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  })),
  footerStyle: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  linkStyle: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  linkHoverStyle: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))
};

exports.LEFT = LEFT;
exports.RIGHT = RIGHT;
exports.default = NarvarFooter;
//# sourceMappingURL=index.js.map
